import React from "react";
import AppRouter from "../routes/AppRouter";
import { PokemonListContext } from "../context/pokemonContext";
import { filterReducer, pokemonReducer } from "../reducer/pokemon";

const App = () => {

    const [pokemons, dispatchPokemons] = React.useReducer(pokemonReducer, []);
    const [filters, dispatchFilters]=React.useReducer(filterReducer, { filter:'', count:48});

    const provider = {
        pokemons,
        dispatchPokemons,
        filters,
        dispatchFilters,
    };

    return (
        <PokemonListContext.Provider value={provider}>
            <AppRouter />
        </PokemonListContext.Provider>
    );
};

export default App;